// Opens a product-info tab from a control elsewhere on the page - today the
// "Size & Fit Guide" link beside the Size option.

function tabButtonFor(trigger) {
  const tabTitle = trigger.getAttribute('data-open-product-tab');
  if (!tabTitle) return null;
  return document.querySelector(
    `.product-info-tabs__tab-button[data-tab-title="${CSS.escape(tabTitle)}"]`
  );
}

// HIDE A TRIGGER WHOSE TAB IS NOT THERE.
//
// The click handler below already returns early when the tab is missing, so a
// dead link never errored - it just silently did nothing, which is worse than
// not being there at all (merchant, 2026-09-06). Two populations need this:
//
//   * 23 of the 67 single-Size products are accessories - replacement pads,
//     straps, extension panels, adjustment keys - with no Size & Fit content.
//   * 9 multi-size products carry Size & Fit prose that says "read your size
//     off the chart below" while having neither a size_chart_table nor a chart
//     image. Those are a copy bug being fixed separately; hiding the link stops
//     the page pointing at nothing in the meantime.
//
// Gating in JS rather than Liquid is deliberate: the tab's own visibility is
// decided by the tabs block from its metafield settings, so asking the DOM
// "did that tab render?" cannot drift from it, while re-deriving the same
// condition from metafield names in a second template certainly would.
function hideTriggersWithNoTab() {
  for (const trigger of document.querySelectorAll('[data-open-product-tab]')) {
    if (!tabButtonFor(trigger)) trigger.hidden = true;
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', hideTriggersWithNoTab);
} else {
  hideTriggersWithNoTab();
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const trigger = event.target.closest('[data-open-product-tab]');
  if (!trigger) return;

  const tabButton = tabButtonFor(trigger);
  if (!tabButton) return;

  tabButton.click();
  tabButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
});
